import { createFileRoute } from '@tanstack/react-router'
import { AssistantSwitch } from '../../../../components/assistant-switch'
import { InvestorHomeRedirect } from '../../../../components/investor-home-redirect'
import { DealFlowPage } from '../../../../features/legacy-investor/deal-flow-page'

// Deal Flow, which the deal-flow match email links to is gone; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/deal-flow')({
  component: () => (
    <AssistantSwitch assistant={<InvestorHomeRedirect />} classic={<DealFlowPage />} />
  ),
})
